/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */

import CalendarMonthSvg from '@sede-x/shell-ds-foundations/foundations/icons/time/calendar-month.svg';

const CalendarMonth: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <CalendarMonthSvg className="shell-icon" {...props} />
);

export default CalendarMonth;
